import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const FAQ = () => {
  return (
    <div className="bg-gray-900 pt-14 min-h-screen">
      <Helmet>
        <title>FAQ - Questions Fréquemment Posées | WebMinds</title>
        <meta
          name="description"
          content="Trouvez des réponses à vos questions sur nos services de développement d'applications mobiles et de design graphique. Consultez notre FAQ pour en savoir plus sur WebMinds."
        />
        <meta
          name="keywords"
          content="FAQ, questions fréquentes, WebMinds, développement d'applications, design graphique, support client, services web"
        />
      </Helmet>

      <Navbar />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-8 text-center">
          {" "}
          {/* Changement de text-blue-900 à text-white */}
          Questions Fréquemment Posées
        </h1>

        {/* Section Développement Web */}
        <section id="web-development" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-blue-400 pb-2">
            {" "}
            {/* Changement de text-blue-800 à text-white */}
            Développement Web
          </h2>
          <div className="space-y-6">
            {/* Question 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              {" "}
              {/* Changement de bg-white à bg-gray-800 */}
              <h3 className="text-xl font-semibold text-white mb-2">
                {" "}
                {/* Changement de text-gray-900 à text-white */}
                Quels types de sites web développez-vous ?
              </h3>
              <p className="text-gray-400">
                {" "}
                {/* Changement de text-gray-700 à text-gray-400 */}
                Nous développons des sites vitrines, des sites e-commerce, des
                blogs, et des plateformes personnalisées en fonction de vos
                besoins.
              </p>
            </div>
            {/* Question 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quels sont les délais pour la création d'un site web ?
              </h3>
              <p className="text-gray-400">
                Les délais varient selon la complexité du projet, mais en
                général, un site vitrine peut être créé en 4 à 6 semaines et un
                site e-commerce en 8 à 12 semaines.
              </p>
            </div>
            {/* Question 3 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Fournissez-vous un support après la mise en ligne ?
              </h3>
              <p className="text-gray-400">
                Oui, nous offrons un support technique post-lancement pour
                résoudre tout problème et effectuer des mises à jour
                nécessaires.
              </p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Fournissez-vous des services de gestion de contenu ?
              </h3>
              <p className="text-gray-400">
                Oui, nous offrons des services complets de gestion de contenu
                pour vous aider à maintenir et à mettre à jour votre site web.
                Cela inclut la gestion des articles de blog, des pages de
                contenu, et des médias, ainsi que l’assistance pour utiliser et
                personnaliser votre système de gestion de contenu (CMS).
              </p>
            </div>
          </div>
        </section>

        {/* Section Développement Mobile */}
        <section id="mobile-development" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-green-400 pb-2">
            {" "}
            {/* Changement de text-blue-800 à text-white */}
            Développement Mobile
          </h2>
          <div className="space-y-6">
            {/* Question 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quels systèmes d'exploitation couvrez-vous pour les applications
                mobiles ?
              </h3>
              <p className="text-gray-400">
                Nous développons des applications pour iOS et Android, en
                utilisant des technologies natives ou des frameworks
                multiplateformes comme React Native.
              </p>
            </div>
            {/* Question 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quelle est la durée de développement d'une application mobile ?
              </h3>
              <p className="text-gray-400">
                Le développement peut prendre de 3 à 6 mois en fonction de la
                complexité de l'application et des fonctionnalités requises.
              </p>
            </div>
            {/* Question 3 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Offrez-vous des services de maintenance pour les applications
                mobiles ?
              </h3>
              <p className="text-gray-400">
                Oui, nous proposons des services de maintenance pour assurer que
                votre application reste à jour et fonctionne correctement.
              </p>
            </div>
          </div>
        </section>

        {/* Section SEO & Marketing */}
        <section id="seo-marketing" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-yellow-400 pb-2">
            {" "}
            {/* Changement de text-blue-800 à text-white */}
            SEO & Marketing
          </h2>
          <div className="space-y-6">
            {/* Question 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quelles sont les techniques de SEO que vous utilisez ?
              </h3>
              <p className="text-gray-400">
                Nous utilisons des techniques telles que l'optimisation des
                mots-clés, l'amélioration de la structure du site, le link
                building, et l'optimisation du contenu.
              </p>
            </div>
            {/* Question 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Comment mesurez-vous le succès d'une campagne SEO ?
              </h3>
              <p className="text-gray-400">
                Nous mesurons le succès en surveillant les classements des
                mots-clés, le trafic organique, les taux de conversion, et
                d'autres indicateurs de performance.
              </p>
            </div>
            {/* Question 3 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quels types de marketing digital proposez-vous ?
              </h3>
              <p className="text-gray-400">
                Nous proposons des services de publicité pay-per-click, de
                marketing sur les réseaux sociaux, de marketing par e-mail, et
                d'analyse des performances.
              </p>
            </div>
          </div>
        </section>

        {/* Section Conception Graphique */}
        <section id="graphic-design" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-purple-400 pb-2">
            {" "}
            {/* Changement de text-blue-800 à text-white */}
            Conception Graphique
          </h2>
          <div className="space-y-6">
            {/* Question 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quels types de supports graphiques créez-vous ?
              </h3>
              <p className="text-gray-400">
                Nous créons des supports variés tels que des logos, des
                brochures, des affiches, des infographies, et des visuels pour
                les réseaux sociaux.
              </p>
            </div>
            {/* Question 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quel est le processus de création d'une identité visuelle ?
              </h3>
              <p className="text-gray-400">
                Le processus inclut la compréhension de vos objectifs, la
                recherche de tendances, la conception de concepts, les
                révisions, et la livraison des fichiers finaux.
              </p>
            </div>
            {/* Question 3 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Pouvez-vous créer des visuels pour les réseaux sociaux ?
              </h3>
              <p className="text-gray-400">
                Oui, nous créons des visuels engageants pour les réseaux sociaux
                afin d'améliorer votre présence en ligne et d'attirer
                l'attention de votre audience.
              </p>
            </div>
          </div>
        </section>

        {/* Section Réseaux Sociaux */}
        <section id="social-media" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-red-400 pb-2">
            {" "}
            {/* Changement de text-blue-800 à text-white */}
            Réseaux Sociaux
          </h2>
          <div className="space-y-6">
            {/* Question 1 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Quels services proposez-vous pour la gestion des réseaux sociaux
                ?
              </h3>
              <p className="text-gray-400">
                Nous proposons la gestion de contenu, l'engagement avec votre
                audience, la création de campagnes publicitaires, et l'analyse
                des performances.
              </p>
            </div>
            {/* Question 2 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Comment mesurez-vous l’efficacité d’une campagne sur les réseaux
                sociaux ?
              </h3>
              <p className="text-gray-400">
                Nous mesurons l’efficacité par l’analyse des engagements, des
                conversions, du taux de clics, et de la portée des publications.
              </p>
            </div>
            {/* Question 3 */}
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-white mb-2">
                Offrez-vous des conseils pour améliorer la présence en ligne ?
              </h3>
              <p className="text-gray-400">
                Oui, nous offrons des consultations pour optimiser votre
                stratégie sur les réseaux sociaux et améliorer votre présence en
                ligne.
              </p>
            </div>
          </div>
        </section>

        {/* CTA vers Contact */}
        <div className="text-center mt-16">
          <h3 className="text-2xl font-semibold text-white mb-4">
            {" "}
            {/* Changement de text-blue-900 à text-white */}
            Vous avez d'autres questions ?
          </h3>
          <p className="text-lg text-gray-400 mb-6">
            {" "}
            {/* Changement de text-gray-700 à text-gray-400 */}
            Si vous avez d'autres questions ou si vous avez besoin de
            précisions, n'hésitez pas à nous contacter. Nous sommes là pour vous
            aider !
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-md hover:bg-blue-500 transition-colors duration-300"
          >
            Contactez-nous
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;
